<script lang="ts">
	// app
	import { page } from '$app/stores';

	// components
	import Button from '$components/utilities/Button.svelte';
	import DataCard from '$components/layout/DataCard.svelte';
	import Link from '$components/utilities/Link.svelte';
	import Seo from '$components/utilities/seo/index.svelte';

	// icons
	import ArrowRight from 'carbon-icons-svelte/lib/ArrowRight.svelte';
	import CalendarHeatMap from 'carbon-icons-svelte/lib/CalendarHeatMap.svelte';
	import ChartEvaluation from 'carbon-icons-svelte/lib/ChartEvaluation.svelte';
	import Cookie from 'carbon-icons-svelte/lib/Cookie.svelte';
	import Cut from 'carbon-icons-svelte/lib/Cut.svelte';
	import Dashboard from 'carbon-icons-svelte/lib/Dashboard.svelte';
	import TouchInteraction from 'carbon-icons-svelte/lib/TouchInteraction.svelte';

	// seo
	const slug = 'affiliate';
	const shortMetaDescription =
		'Become a Leadgeek affiliate and earn a 25% lifetime commission from any new client you refer';
	const title = 'Affiliate';
	const seoProps = {
		breadcrumbs: [{ title, slug }],
		keywords: ['leadgeek affiliate', 'online arbitrage affiliate'],
		kind: 'community',
		metaDescription:
			shortMetaDescription + ". You don't have to be a customer to join the program.",
		readingTime: '3 mins.',
		shortMetaDescription,
		slug,
		title,
		updatedAt: '2022-10-24T00:00:00.000+0100',
	};
</script>

<Seo {...seoProps} />

<section class="content-section-text mt-content mb-content">
	<header class="md:text-center">
		<h1 class="primary-header">
			Affiliate <span role="img" aria-label="Handshake emoji">🤝</span>
		</h1>
		<p class="sub-header mx-auto mt-5">
			We recognize that you've worked hard building a side-hustle that helps people side-hustle.
			Increase the earnings from your YouTube channel, Discord server, or blog with a product that
			you can stand behind.
		</p>
		<Button
			class="mx-auto mt-5"
			href={$page.data.profile ? '/account/profile#affiliate' : '/sign-up'}
			icon={ArrowRight}
			title="Sign up"
		/>
	</header>
	<div class="mt-content mx-auto max-w-3xl">
		<ul class="space-y-12">
			<DataCard class="rotate-1" title="The benefits">
				<ul class="mx-auto mt-5 w-full" slot="description">
					{#each [{ icon: Cut, title: 'Receive a 25% lifetime cut of any Kit when you refer a new customer.' }, { icon: Cookie, title: 'Get plenty of time to make the conversion with 90-day cookies.' }, { icon: TouchInteraction, title: "Our first-touch attribution model gives 100% credit to you if you're the original referrer." }, { icon: Dashboard, title: 'See your transactions in real-time with a custom affiliate dashboard.' }, { icon: CalendarHeatMap, title: 'Get paid monthly & on time via PayPal for commissions that are more than 60 days old.' }, { icon: ChartEvaluation, title: 'No minimum payout thresholds, no maximum earning caps.' }] as dataPoint}
						<li class="mt-3 flex space-x-3">
							<svelte:component this={dataPoint.icon} class="flex-none" size={20} />
							<span class="text-zinc-200">{dataPoint.title}</span>
						</li>
					{/each}
				</ul>
			</DataCard>
			<DataCard title="Please note">
				<p slot="description">
					If you'd like to become an affiliate but aren't an Amazon seller, please <Link
						href="/contact?reason=6"
						isUnderlined
						title="contact support"
					/>. It's not a requirement to sell Amazon in order to be a Leadgeek affiliate, but your
					account will have to go through a different creation process.
				</p>
			</DataCard>
		</ul>
	</div>
</section>
